import httpUtils from '@/utils/http-utils';
import i18n from '@/plugins/vue-i18n';

const baseRequesterOptions = {
  baseUrl: `${window.processEnv.VUE_APP_CMS_API_BASE_URL}/countries`,
  requesterType: 'CMS_WEB_SERVICE',
};
const countryApiReqNotification = httpUtils.createRequester(baseRequesterOptions);
const countryApiReqErrorHandling = httpUtils.createRequester(baseRequesterOptions, 'errorHandling');

const getRequester = (errorManagementType) => {
  if (errorManagementType === 'errorHandling') {
    return countryApiReqErrorHandling;
  }

  return countryApiReqNotification;
};

class CountryApi {
  fetchCountries(withResultsIn, errorManagementType) {
    return getRequester(errorManagementType)
      .get('/', {
        params: {
          withResultsIn,
        },
        headers: {
          'accept-language': i18n.locale,
        },
      }).then(res => res && res.data);
  }
}

export default new CountryApi();
